import { render, staticRenderFns } from "./orderPaySuccess.vue?vue&type=template&id=1dca6dde&scoped=true"
import script from "./orderPaySuccess.vue?vue&type=script&lang=js"
export * from "./orderPaySuccess.vue?vue&type=script&lang=js"
import style0 from "./orderPaySuccess.vue?vue&type=style&index=0&id=1dca6dde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca6dde",
  null
  
)

export default component.exports